module.exports = __webpack_public_path__ + "img/logo3.3a25fb86.png";